import { useCallback, useState } from 'react'
import classNames from 'classnames'

import localStorageUtils from 'utils/localStorageUtils'

import type { IInputActionProps, IInputActionViewProps } from './input-action.types'

export function useInputAction({
  className,
  disabled,
  onChange,
  searchKey = 'video-search-terms',
  onClick,
  value,
  showDatalist,
  ...props
}: IInputActionProps): IInputActionViewProps {
  const [searchTerms, setSearchTerms] = useState<string[]>(() => localStorageUtils.getObject(searchKey) ?? [])
  const containerClass = classNames('input-action-container', { disabled }, className)

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = event => {
    const value = event.currentTarget.value
    onChange(value)
  }

  const handleKeyPress: React.KeyboardEventHandler<HTMLInputElement> = useCallback(
    event => {
      if (event.key === 'Enter') {
        const value = event.currentTarget.value
        if (onClick) {
          onClick(value)
        }
        if (showDatalist) {
          const currentDataList = searchTerms
          const cleanDataList = currentDataList.filter(term => term !== value)
          const newList = [value, ...cleanDataList].slice(0, 10)
          localStorageUtils.setObject(searchKey, newList)
          setSearchTerms(newList)
        }
      }
    },
    [onClick, searchKey, searchTerms, showDatalist]
  )

  return {
    containerClass,
    onChange: handleChange,
    searchTerms,
    value,
    disabled,
    onKeyPress: handleKeyPress,
    showDatalist,
    ...props,
  }
}
